import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import PasswordResetPage from "./pages/PasswordReset";
import SocialSuccess from "./pages/SocialSuccess";
import Layout from "./pages/Layout";
import ChatPage from "./pages/ChatPage";
import PaymentPlans from "./pages/PaymentPlans";
import SettingsPage from "./pages/SettingsPage";
import SupportPage from "./pages/SupportPage";
import ProgressPage from "./pages/ProgressPage";
import InvitePage from "./pages/InvitePage";
import FriendsPage from "./pages/FriendsPage";
import DavetFirsat from "./pages/DavetFirsat";
import HemenBasla from "./pages/HemenBasla";
import FirsatDeneme from "./pages/FirsatDeneme";

const isAuth = () => !!localStorage.getItem('biyz_token');

const Private = ({ children }) => {
  const loc = useLocation();
  return isAuth() ? children : <Navigate to="/login" replace state={{ from: loc.pathname + loc.search }} />;
};

const App = () => (
  <Router>
    <Routes>
      <Route path="/" element={<Navigate to={isAuth() ? "/chat" : "/login"} replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/password-reset" element={<PasswordResetPage />} />
      <Route path="/reset-password" element={<PasswordResetPage />} />
      <Route path="/auth/social-success" element={<SocialSuccess />} />
      <Route path="/chat" element={<Private><Layout><ChatPage /></Layout></Private>} />
      <Route path="/home" element={<Private><Layout><ChatPage /></Layout></Private>} />
      <Route path="/packages" element={<Private><Layout><PaymentPlans /></Layout></Private>} />
      <Route path="/davet-firsati" element={<DavetFirsat />} />
      <Route path="/davet-firsati/:ref" element={<DavetFirsat />} />
      <Route path="/basla/:bot" element={<HemenBasla />} />
      <Route path="/settings" element={<Private><Layout><SettingsPage /></Layout></Private>} />
      <Route path="/ilerleme" element={<Private><Layout><ProgressPage /></Layout></Private>} />
      <Route path="/davet" element={<Private><Layout><InvitePage /></Layout></Private>} />
      <Route path="/arkadaslar" element={<Private><Layout><FriendsPage /></Layout></Private>} />
      <Route path="/support" element={<Private><Layout><SupportPage /></Layout></Private>} />
      <Route path="/firsat" element={<Private><Layout><FirsatDeneme /></Layout></Private>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </Router>
);

export default App;

